import { Box, Typography } from "@mui/material";

const PriceItem = ({ label, value, icon }) => (
    <Box
      sx={{
        backgroundColor: "white",
        borderRadius: "8px",
        p: 2,
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        textAlign: "center",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        {icon}
        <Typography
          variant="body2"
          sx={{ color: "#5D6D7E", fontWeight: "600", ml: 0.5 }}
        >
          {label}
        </Typography>
      </Box>
      <Typography
        variant="h6"
        sx={{
          color: "#2C3E50",
          fontWeight: "700",
          mt: 1,
          fontSize: "1.1rem",
        }}
      >
        ${value}
      </Typography>
    </Box>
  );

  export default PriceItem;